<ng-select
  class="custom"
  [placeholder]="placeholder"
  [(ngModel)]="terminalType"
  [items]="terminalTypeList | async"
  [typeahead]="typeahead"
  (change)="onChange($event)"
  (open)="onOpen()">
  <ng-template ng-label-tmp let-item="item">
    {{ item.name }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.name }}
  </ng-template>
</ng-select>
